export const PERMS = {
    READ: 'packaging_types.read',
    UPDATE: 'packaging_types.update',
    DELETE: 'packaging_types.delete',
    CREATE: 'packaging_types.create',
    EXPORT: 'packaging_types.export',
}
